
<div class="fill-parent">
  <div class="fill-parent display-flex padding-l header align-items-centered fill-width">

    <div class="admin-logo">
      <img src="assets/images/MERLIN.svg" />
    </div>
    <div class="flex-grow-1"></div>
    <div class="user-name">
      <span>
        <button mat-button [matMenuTriggerFor]="menu" class="">
          <img src="assets/images/user-circle.svg" /> <span class="normal  margin-l-s bold hide-me-on-mobile">User Name </span>   
            <mat-icon class="icon-color user-name-arrwo">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <mat-icon class="icon-color">logout</mat-icon>
            <span>Log Out</span>
          </button>

        </mat-menu>
      </span>
    </div>
  </div>
  <div class="display-flex">
    <div class="user-menu">
      <div class=" text-center margin-t-l margin-b-l"><span class="bold large-font">Project Name<img src="assets/images/active.png" class="margin-b-l" /></span></div>
      <div class="menu-items-cont">
        <div class="menu-item active-link" >
          <div class="menu-icon">
            <app-icon [iconName]="'map'" [color]="selectedColor"></app-icon>
          </div>
          <div class="menu-text">
            Map
          </div>
        </div>
        <div class="menu-item">
          <div class="menu-icon">

            <app-icon [iconName]="'sites'" [color]="noramalColor"></app-icon>
          </div>
          <div class="menu-text">
            Sites
          </div>
        </div>
        <div class="menu-item">
          <div class="menu-icon">
            <app-icon [iconName]="'devices'" [color]="noramalColor"></app-icon>
          </div>
          <div class="menu-text">
            Devices
          </div>
        </div>
        <div class="menu-item">
          <div class="menu-icon">
            <app-icon [iconName]="'user'" [color]="noramalColor"></app-icon>
          </div>
          <div class="menu-text">
            Participants
          </div>
        </div>

      </div>
      <div class="menu-item">
        <div class="menu-icon">
          <app-icon [iconName]="'survey'" [color]="noramalColor"></app-icon>
        </div>
        <div class="menu-text">
          Documents
        </div>
      </div>
    </div>


    <div class="flex-grow-1 padding-xl">
    <!--<router-outlet></router-outlet>-->
      <app-projectmap></app-projectmap>
    </div>
  </div>


</div>




